import {loadable} from 'router/routes';
import getInitialState from './redux/get-initial-state';

const Confirmation = loadable(() => import('./Confirmation'));

Confirmation.getInitialState = getInitialState;

export default Confirmation;
